import React from 'react';
import styled from 'styled-components';
import { ListItem } from './MenuItem';

const variants = {
  open: {
    y: 0,
    width: '100%',
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    width: 0,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

const Separator = styled.div`
  width: 80%;
  height: 1px;
  background: black;
`;

const ListSeparator = () => (
  <ListItem variants={variants}>
    <Separator />
  </ListItem>
);

export default ListSeparator;